export const REQUEST_COLLECTION_ROWS = 'concrete/REQUEST_COLLECTION_ROWS'
export const RECEIVE_COLLECTION_ROWS = 'concrete/RECEIVE_COLLECTION_ROWS'
export const ERROR_COLLECTION_ROWS = 'concrete/ERROR_COLLECTION_ROWS'
export const CLEAR_COLLECTION_ROWS = 'concrete/CLEAR_COLLECTION_ROWS'



// WEBPACK FOOTER //
// ./src/components/collection-container/action-types.js